export const BTN_ON = 'btn-dark';
export const BTN_OFF = 'btn-outline-dark';

export const COLORS = [  "#A6D8FF",
    "#FFA6A6",
    "#FFE2A6",
    "#F2D3FF",
    "#A6FFA6",
    "#FFA6FF",
    "#FFDFA6",
    "#A6FFF2",
    "#FFA6A6",
    "#FFDFA6",
    "#FFA6FF",
    "#A6FFA6",
    "#DFA6DF",
    "#FFE2D8",
    "#A6E2FF",
    "#FFDFAF",
    "#E2FFAF",
    "#A6A6FF",
    "#A6FFA6",
    "#FFAFAF",
    "#DFA6FF",
    "#FFA6A6",
    "#FFE9E9",
    "#AFAFFF",
    "#E2A6E2",
    "#AFAFFF",
    "#FFE2E2",
    "#FFE9C6",
    "#FFA6A6",
    "#D8A6A6",
    "#A6FFAF",
    "#A6D8AF",
    "#FFE2E2",
    "#FFA6FF",
    "#A6FFE2",
    "#E2A6E2",
    "#A6D8D8",
    "#FFD8D8",
    "#A6AFD8",
    "#E2D8D8",
    "#AFAFF2",
    "#FFE2E2"];